import Vue from 'vue'
import moment from 'moment-timezone'

// file size format humanizer
Vue.filter('formatSize', function (size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB'
    } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB'
    } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(2) + ' MB'
    } else if (size > 1024) {
        return (size / 1024).toFixed(2) + ' KB'
    }
    return size.toString() + ' B'
})

Vue.filter('carbonDate', function(date, format, fromNow) {
    if(!date || typeof date !== 'object' || !('date' in date) || !('timezone' in date)) {
        return ""
    }
    let funkyDate = moment.tz(date.date, date.timezone)
    if(typeof fromNow === 'boolean' && fromNow === true) {
        return funkyDate.fromNow()
    } else {
        return format ? funkyDate.format(format) : funkyDate.format("dddd, D MMMM YYYY, h:mm a")
    }
})

Vue.filter('number', function(n){
    if(n === 0) {
        return n
    }
    return n ? n.toLocaleString() : "";
})
